import { useParams } from 'react-router-dom';

import { ParamsProps } from '../components/live-event/live-event';

export const useGetLanguage = (): string => {
	const params = useParams() as unknown as ParamsProps;
	
	return params?.language || 'en';
};